module.exports = __webpack_public_path__ + "static/img/open_box.c54dc1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize_pop_up/open_box.png
// module id = Gevr
// module chunks = 1